import React from 'react';
import cn from './../../lib/bem';

import './inputSelect_component.scss';
import {
  MASCULINO_VALUE,
  FEMININO_VALUE,
} from '../../domains/commons/constants';

const InputSelectComponent = (props) => {
  const classes = cn('inputSelectComponent');

  const onChangeTipoSelect = (value) => {
    props.inputActionMsg('');
    props.inputAction(value);
  };

  return (
    <div className={classes()} style={{ width: `${props.inputWidth}%` }}>
      <label className={classes('inputSelectLabel')}>{props.inputText}</label>
      <select
        className={
          props.inputMsg === ''
            ? classes('inputSelect')
            : classes('inputSelect inputError')
        }
        name={`txt_${props.inputText}`}
        value={props.inputValue}
        onChange={(e) => onChangeTipoSelect(e.target.value)}
        required
      >
        <option hidden value="">
          Seleccionar
        </option>
        <option value={MASCULINO_VALUE}>Masculino</option>
        <option value={FEMININO_VALUE}>Femenino</option>
      </select>
      <label className={classes('inputSelectLabelError')}>
        {props.inputMsg}
      </label>
    </div>
  );
};

export default InputSelectComponent;
